// extracted by mini-css-extract-plugin
export default {"memberCard":"MemberCard_memberCard__6J9hO"};